module.exports = __webpack_public_path__ + "media/r_fuddiputze.0330ea13.mp3";